import FrontText from "@/Components/Front/FrontText";
import FrontLayout from "@/Layouts/System/FrontLayout";
import { useTranslation } from "react-i18next";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import Column from "@/Components/Grid/Column";
import FrontStandardSearcher from "@/Components/Front/Forms/FrontStandardSearcher";
import resolveLocaleRoute from "@/Helpers/resolveLocaleRoute";
import FrontPagination from "@/Components/Front/FrontPagination";
import FrontStickySeeOnMap from "@/Components/Front/Blocks/FrontStickySeeOnMap";
import FrontViewOnMap from "@/Components/Front/Blocks/FrontViewOnMap";
import FrontWarehousesLoop from "@/Components/Front/Blocks/FrontWarehousesLoop";
import FrontSeoMetaTags from "@/Components/Front/Partials/FrontSeoMetaTags";

const WarehousesDashboardAll = ({ seo, viewWarehouses, countWarehouses, cities, warehouses, regions, queryParams = {} }) => {
    const { t, i18n } = useTranslation();
    
    return (
        <FrontLayout
            breadcrumbs={[
                { title: t("breadcrumbs.allWarehouses"), current: true },
            ]}
        >

            <FrontSeoMetaTags seo={seo}/>
            <Container>
                <Row>
                    <Column>
                        {/* =================== [Dodatek, po akceptacji podmienić klasę na [lg:my-10 md:my-5]] =================== */}
                        <FrontText
                            textSize="28/32"
                            className="text-center text-heading-blue font-bold lg:my-10 md:my-5"
                        >
                            <h1>{t("warehouses.heading")}</h1>
                        </FrontText>
                    </Column>
                </Row>
            </Container>

            <FrontStandardSearcher countWarehouses={countWarehouses} cities={cities} warehouses={warehouses} regions={regions} queryParams={queryParams} filterRoute={'front.warehouses.all'}/>

            <section id="map">
                <FrontViewOnMap link={resolveLocaleRoute('front.warehouses.all.map', null, i18n.resolvedLanguage)}/>
            </section>

            <section id="warehouses-loop" className="lg:mt-20 mt-15 relative">
                <FrontStickySeeOnMap link={resolveLocaleRoute('front.warehouses.all.map', null, i18n.resolvedLanguage)}/>

                <FrontWarehousesLoop warehouses={viewWarehouses.data}/>
            </section>
            
            <FrontPagination links={viewWarehouses.links} />
        </FrontLayout>
    );
};

export default WarehousesDashboardAll;
